import $ from 'jquery';
import BaseComponent from 'components/BaseComponent';

export default class CollapsibleComponent extends BaseComponent {
    constructor($element, options) {
        super($element, options);

        this.isExpanded = false;

        this.init();
    }

    static defaults = {
    }

    SELECTOR = {
        TRIGGER: '[data-collapsible-trigger]',
        PANEL: '[data-collapsible-panel]',
        CONTENT: '[data-collapsible-panel-content]',
    }

    STATE = {
        EXPANDED: 's-isExpanded',
    }

    /**
     * Binds the scope of any handler functions.
     * Should only be run on initialization of the view.
     *
     * @method setupHandlers
     * @returns {CollapsibleComponent}
     * @private
     */
    setupHandlers() {
        // Bind event handlers scope here
        this.onTriggerClickHander = this.onTriggerClick.bind(this);

        return this;
    }

    /**
     * Create any child objects or references to DOM elements.
     * Should only be run on initialization of the view.
     *
     * @method createChildren
     * @returns {CollapsibleComponent}
     * @private
     */
    createChildren() {
        super.createChildren();

        this.$trigger = this.$element.find(this.SELECTOR.TRIGGER);
        this.$panel = this.$element.find(this.SELECTOR.PANEL);
        this.$content = this.$element.find(this.SELECTOR.CONTENT);

        return this;
    }

    /**
     * Remove any child objects or references to DOM elements.
     *
     * @method removeChildren
     * @returns {CollapsibleComponent}
     * @public
     */
    removeChildren() {
        super.removeChildren();

        return this;
    }

    layout() {
        super.layout();

        this.$panel.css('height', '0');

        return this;
    }

    /**
     * Enables the component.
     * Performs any event binding to handlers.
     * Exits early if it is already enabled.
     *
     * @method enable
     * @returns {CollapsibleComponent}
     * @public
     */
    enable() {
        if (this.isEnabled) {
            return this;
        }
        this.isEnabled = true;

        this.$trigger.on('click', this.onTriggerClickHander);

        return this;
    }

    /**
     * Disables the component.
     * Tears down any event binding to handlers.
     * Exits early if it is already disabled.
     *
     * @method disable
     * @returns {CollapsibleComponent}
     * @public
     */
    disable() {
        if (!this.isEnabled) {
            return this;
        }
        this.isEnabled = false;


        return this;
    }

    /*
        EVENT HANDLERS
    */
    onTriggerClick(e) {
        e.preventDefault();

        this.toggle();
    }

    toggle() {
        this.isExpanded ? this.collapsePanel() : this.expandPanel();
    }

    expandPanel() {
        this.isExpanded = true;
        const transitionDuration = parseFloat(this.$panel.css('transitionDuration')) * 1000;

        this.$trigger.addClass(this.STATE.EXPANDED)
                     .attr('aria-expanded', 'true');

        this.$panel.css('height', `${this.getPanelContentHeight()}px`)
                   .attr('aria-hidden', 'false');

        setTimeout(() => {
            this.$panel.css('height', '');
        }, transitionDuration);
    }

    collapsePanel() {
        this.isExpanded = false;

        this.$trigger.removeClass(this.STATE.EXPANDED)
                     .attr('aria-expanded', 'false');

        this.$panel.css('height', `${this.getPanelContentHeight()}px`)
                   .attr('aria-hidden', 'true');

        setTimeout(() => {
            this.$panel.css('height', '0');
        }, 0);
    }

    getPanelContentHeight() {
        return this.$content.outerHeight();
    }
}
